import React, { ReactNode } from 'react';
import { useCurrentUser } from './hook';
import { State } from './types';

type ProviderValue = {
  state: State;
  fetchCurrentUser: () => void;
};

const CurrentUserContext = React.createContext<ProviderValue>({
  state: {
    userId: null,
    webStationId: null,
    status: 'idle',
    imageUrl: null,
  },
  fetchCurrentUser: () => {},
});

export const useCurrentUserCtx = () => React.useContext(CurrentUserContext);

export const CurrentUserProvider = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const { state, fetchCurrentUser } = useCurrentUser();

  return (
    <CurrentUserContext.Provider value={{ state, fetchCurrentUser }}>
      {children}
    </CurrentUserContext.Provider>
  );
};
